var _style, _rect, _path, _path2, _path3, _g, _g2, _g3, _g4, _g5, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChileElige2024({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 345 110",
    style: {
      enableBackground: "new 0 0 345 110"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#979797;}\n\t.st1{fill:url(#Trazado_49_1_);}\n\t.st2{fill:#EDEDED;}\n\t.st3{fill:#666666;}\n\t.st4{enable-background:new    ;}\n\t.st5{fill:#D4222C;}\n\t.st6{fill:#4C4D5A;}\n\t.st7{fill:#1D63DC;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_245",
    transform: "translate(-484.45 -382.269)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_243",
    transform: "translate(118.06 0.187)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_94",
    x: 486.2,
    y: 454.6,
    className: "st0",
    width: 95.8,
    height: 7.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_49_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 369.4576,
    y1: 489.0239,
    x2: 369.5396,
    y2: 489.7189,
    gradientTransform: "matrix(86.4886 0 0 -78.6721 -31418.5742 38924.1484)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F79E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3E63D7"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_49",
    className: "st1",
    d: "M521.7,462.3h22.9l34-21.6c3.1-2,4.1-6.1,2.1-9.3c0,0,0,0,0,0l-28.3-44.7 c-2-3.1-6.1-4.1-9.3-2.1L498.4,413c-3.1,2-4.1,6.1-2.1,9.3L521.7,462.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_50",
    className: "st2",
    d: "M544.6,406.9l1.3,12.4c0.1,0.7,0.6,1.3,1.3,1.4l12.1,2.8c0.9,0.2,1.4,1.1,1.2,2 c-0.1,0.5-0.5,0.9-0.9,1.1l-11.4,5c-0.6,0.3-1,0.9-1,1.6l1.1,12.4c0.1,0.9-0.6,1.7-1.5,1.8c-0.5,0-1-0.2-1.4-0.5l-8.3-9.3 c-0.5-0.5-1.2-0.7-1.9-0.4l-11.5,4.8c-0.8,0.4-1.8,0-2.1-0.9c-0.2-0.5-0.2-1,0.1-1.5l6.2-10.8c0.3-0.6,0.3-1.4-0.2-1.9l-8.1-9.4 c-0.6-0.7-0.5-1.7,0.2-2.3c0.4-0.3,0.9-0.5,1.4-0.4l12.2,2.6c0.7,0.1,1.4-0.2,1.7-0.8l6.4-10.7c0.5-0.8,1.5-1,2.2-0.6 C544.2,405.9,544.5,406.4,544.6,406.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_51",
    className: "st3",
    d: "M556.8,454.6h6.1l-5.7,7.7h-12.6L556.8,454.6z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M704.8,461.2v-60.6h22.8v10h-13v14.9h12.7v9.5h-12.7v15.7h12.9v10.5H704.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M732.5,461.2v-60.6h9.8v50.1h11.8v10.5H732.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M758,461.2v-60.6h10.1v60.6H758z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M785.3,436.2v-9.5h14.9c0.1,1,0.1,2.4,0.1,4.3c0,1.8,0,4,0,6.6c0,3.2-0.1,5.9-0.2,8c-0.1,2.2-0.3,4-0.5,5.4 c-0.2,1.5-0.5,2.7-0.8,3.6c-0.3,1-0.6,1.8-1,2.6c-0.9,1.9-2.2,3.2-3.9,3.9c-1.7,0.7-4.2,1.1-7.4,1.1c-3.3,0-5.8-0.4-7.5-1.1 c-1.7-0.7-3-2-3.9-3.9c-0.4-0.9-0.8-1.9-1.1-3c-0.3-1.1-0.6-2.6-0.8-4.5c-0.2-1.9-0.4-4.4-0.4-7.4s-0.1-7-0.1-11.9 c0-4.7,0-8.5,0.1-11.4c0.1-2.9,0.2-5.3,0.4-7.2c0.2-1.8,0.5-3.3,0.8-4.3c0.3-1,0.7-2,1.1-2.9c0.5-1,1-1.8,1.7-2.4 c0.6-0.6,1.4-1.2,2.3-1.6c0.9-0.4,2-0.7,3.2-0.8c1.2-0.2,2.6-0.2,4.3-0.2c1.7,0,3.2,0.1,4.4,0.2c1.2,0.2,2.3,0.4,3.1,0.8 c0.9,0.4,1.6,0.9,2.1,1.5c0.6,0.6,1.1,1.3,1.6,2.2c0.7,1.4,1.3,3.1,1.6,5.1c0.3,1.9,0.5,4.3,0.5,7.1c0,0.6,0,1.1,0,1.4 c0,0.3,0,0.8-0.1,1.2h-9.3c0.1-0.3,0.1-0.6,0.1-1s0-0.9,0-1.7c0-0.9-0.1-1.8-0.2-2.8c-0.1-1-0.3-1.8-0.4-2.4 c-0.4-1.3-1.5-1.9-3.5-1.9c-1.1,0-1.8,0.2-2.3,0.5c-0.5,0.3-0.9,0.9-1.1,1.8c-0.1,0.5-0.2,1-0.3,1.7c-0.1,0.6-0.2,1.6-0.3,3 c-0.1,1.3-0.1,3.1-0.2,5.3c-0.1,2.2-0.1,5.1-0.1,8.8c0,3.8,0,6.9,0,9.2c0,2.3,0.1,4.1,0.2,5.4c0.1,1.3,0.2,2.3,0.3,3 c0.1,0.6,0.2,1.2,0.4,1.7c0.3,0.9,0.7,1.4,1.2,1.8c0.5,0.3,1.4,0.5,2.5,0.5c1.2,0,2.1-0.2,2.6-0.5c0.5-0.3,0.9-1,1.2-1.9 c0.1-0.5,0.2-1.1,0.3-1.8c0.1-0.7,0.2-1.5,0.2-2.4c0.1-0.9,0.1-1.7,0.1-2.6c0-0.9,0-1.7,0-2.4c0-1,0-1.8,0-2.5 c0-0.6,0-1.2-0.1-1.6H785.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M804.7,461.2v-60.6h22.8v10h-13v14.9h12.7v9.5h-12.7v15.7h12.9v10.5H804.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M510.9,438.1c0.1,0.9,0.2,1.8,0.2,2.8c0,0.9,0,1.8,0,2.8c0,3.2-0.2,6-0.5,8.3c-0.4,2.4-0.9,4.4-1.8,6 c-0.8,1.6-2,2.8-3.4,3.6c-1.4,0.8-3.2,1.2-5.3,1.2c-2.9,0-5-0.4-6.5-1.1c-1.5-0.7-2.6-2-3.3-3.9c-0.4-0.9-0.7-1.9-1-3.1 c-0.3-1.2-0.5-2.8-0.6-4.8c-0.2-2-0.3-4.5-0.4-7.6c-0.1-3.1-0.1-7-0.1-11.7c0-5.5,0.1-9.8,0.2-13c0.1-3.2,0.3-5.7,0.5-7.5 c0.2-1.8,0.5-3.1,0.7-3.8c0.3-0.8,0.5-1.4,0.7-1.9c0.8-1.8,1.8-3,3.1-3.8c1.3-0.8,3.4-1.1,6.3-1.1c2,0,3.6,0.2,4.8,0.5 c1.2,0.4,2.2,1,3.1,1.8c1.1,1.1,1.9,3,2.5,5.7c0.6,2.7,0.9,6,0.9,10c0,1.1,0,2,0,2.8c0,0.8-0.1,1.7-0.1,2.6H504 c0.1-0.9,0.1-1.6,0.1-2.3c0-0.6,0-1.6,0-3c0-2.5-0.1-4.5-0.3-6c-0.2-1.5-0.5-2.6-0.9-3.4c-0.3-0.7-0.7-1.2-1.2-1.4 c-0.5-0.2-1.2-0.3-2-0.3c-1.1,0-1.9,0.2-2.3,0.6c-0.5,0.4-0.9,1.1-1.1,2c-0.2,0.6-0.3,1.4-0.4,2.1c-0.1,0.8-0.2,1.9-0.3,3.4 s-0.1,3.5-0.2,6c0,2.5,0,5.8,0,9.8c0,4,0,7.4,0,10c0,2.6,0.1,4.7,0.2,6.2c0.1,1.6,0.2,2.8,0.3,3.6c0.1,0.9,0.3,1.6,0.4,2.3 c0.3,0.9,0.7,1.6,1.2,2c0.5,0.4,1.4,0.6,2.6,0.6c1,0,1.7-0.3,2.2-0.9c0.5-0.6,0.9-1.4,1.2-2.5c0.3-1.1,0.5-2.3,0.6-3.8 c0.1-1.4,0.2-3.1,0.2-5c0-0.9,0-1.8,0-2.5c0-0.8,0-1.5-0.1-2.3H510.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M532.3,461.6v-27.8h-9.2v27.8h-7.4v-61.3h7.4v26.6h9.2v-26.6h7.3v61.3H532.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M544.9,461.6v-61.3h7.4v61.3H544.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M557.7,461.6v-61.3h7.1v53.7h10.9v7.6H557.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M579.5,461.6v-61.3h19v7.3h-11.8v19.3h11.7v7h-11.7v20.2h11.7v7.6H579.5z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M602.4,475.1h8.2v1.8h-3v9.4h-2.2V477h-3V475.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M612.8,475.1h2.2v6.9c0,1.5,0.8,2.3,2.3,2.3c1.4,0,2.3-0.8,2.3-2.3v-6.9h2.3v6.9c0,2.9-2.1,4.4-4.6,4.4 c-2.4,0-4.5-1.4-4.5-4.4V475.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M634.2,475c2.5,0,4.5,1.3,5.2,3.6h-2.6c-0.5-1.1-1.5-1.6-2.7-1.6c-2,0-3.3,1.4-3.3,3.7c0,2.3,1.4,3.7,3.3,3.7 c1.2,0,2.2-0.5,2.7-1.6h2.6c-0.8,2.3-2.8,3.6-5.2,3.6c-3.2,0-5.7-2.4-5.7-5.7C628.6,477.4,631,475,634.2,475z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M647.2,486.4c-3.2,0-5.7-2.4-5.7-5.7c0-3.3,2.6-5.7,5.7-5.7c3.2,0,5.7,2.4,5.7,5.7 C652.9,484.1,650.4,486.4,647.2,486.4z M647.2,484.4c2,0,3.4-1.5,3.4-3.7c0-2.3-1.4-3.7-3.4-3.7c-2,0-3.4,1.4-3.4,3.7 C643.8,483,645.2,484.4,647.2,484.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M655.2,475.1h2.5l3.6,8.3l3.6-8.3h2.5v11.2h-2.2v-7.3l-3,7.3h-1.7l-3-7.3v7.3h-2.2V475.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M670.2,475.1h2.2v6.9c0,1.5,0.8,2.3,2.3,2.3c1.4,0,2.3-0.8,2.3-2.3v-6.9h2.3v6.9c0,2.9-2.1,4.4-4.6,4.4 c-2.4,0-4.5-1.4-4.5-4.4V475.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M691.6,475.1v11.2h-2.2l-5.1-7.7v7.7H682v-11.2h2.2l5.1,7.7v-7.7H691.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M701.3,484.2h-4.4l-0.7,2.1h-2.4l4-11.2h2.6l4,11.2H702L701.3,484.2z M699.1,477.7l-1.6,4.7h3.2L699.1,477.7z "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M733.1,475.1h8.7v2.2h-3v9h-2.7v-9h-3V475.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M743.7,475.1h2.7v6.7c0,1.3,0.7,2.1,2,2.1c1.3,0,2-0.8,2-2.1v-6.7h2.7v6.7c0,3.1-2.2,4.6-4.8,4.6 c-2.6,0-4.6-1.5-4.6-4.6V475.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M764.3,475.1c2.8,0,4.1,1.6,4.1,3.5c0,1.4-0.8,2.7-2.5,3.2l2.6,4.5h-3.1l-2.3-4.2h-0.7v4.2h-2.7v-11.2H764.3z  M764.2,477.4h-1.7v2.8h1.7c1,0,1.5-0.5,1.5-1.4C765.7,477.9,765.2,477.4,764.2,477.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M777.7,477.3h-4.1v2.3h3.7v2.1h-3.7v2.5h4.1v2.2h-6.9v-11.2h6.9V477.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M790.6,478.6h-3c-0.4-0.8-1.2-1.2-2.2-1.2c-1.8,0-2.9,1.2-2.9,3.2c0,2.1,1.2,3.3,3.2,3.3c1.4,0,2.3-0.7,2.7-2 h-3.5v-2h6v2.5c-0.6,1.9-2.4,3.9-5.4,3.9c-3.4,0-5.7-2.4-5.7-5.7c0-3.4,2.4-5.7,5.7-5.7C788,475,790,476.3,790.6,478.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M792.9,475.1h2.7v11.2h-2.7V475.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M803.6,486.4c-3.2,0-5.8-2.4-5.8-5.8c0-3.4,2.6-5.7,5.8-5.7c3.2,0,5.7,2.4,5.7,5.7 C809.4,484,806.8,486.4,803.6,486.4z M803.6,483.9c1.8,0,3-1.3,3-3.3c0-2-1.2-3.3-3-3.3c-1.8,0-3,1.3-3,3.3 C800.6,482.6,801.8,483.9,803.6,483.9z M805.5,470.7v2.1l-3.9,1.6v-1.9L805.5,470.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M821.6,475.1v11.2h-2.7l-4.6-6.9v6.9h-2.7v-11.2h2.7l4.6,7v-7H821.6z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M487.9,475.2h7.8v1.5h-3v9.6h-1.8v-9.6h-3V475.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M498.3,475.2h1.8v7.1c0,1.7,1,2.5,2.5,2.5c1.6,0,2.5-0.8,2.5-2.5v-7.1h1.8v7.1c0,2.8-2,4.2-4.4,4.2 c-2.3,0-4.3-1.3-4.3-4.2V475.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M519.6,486.3h-4.4v-11.1h4.2c2.4,0,3.6,1.3,3.6,2.9c0,1.3-0.8,2.2-1.9,2.5c1.2,0.2,2.1,1.4,2.1,2.7 C523.2,485,521.9,486.3,519.6,486.3z M519.2,476.7H517v3.2h2.3c1.2,0,1.9-0.6,1.9-1.6C521.1,477.3,520.4,476.7,519.2,476.7z  M519.4,481.4H517v3.5h2.5c1.2,0,2-0.6,2-1.7C521.4,482,520.6,481.4,519.4,481.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M532.7,484h-4.7l-0.8,2.3h-1.9l4-11.1h2.1l4,11.1h-1.9L532.7,484z M530.4,477.4l-1.8,5.2h3.6L530.4,477.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M541.8,475.2c2.6,0,3.9,1.5,3.9,3.3c0,1.3-0.7,2.7-2.6,3.2l2.8,4.6h-2.2l-2.6-4.5h-1.4v4.5H538v-11.1H541.8z  M541.8,476.7h-2v3.7h2c1.4,0,2.1-0.8,2.1-1.9C543.9,477.4,543.2,476.7,541.8,476.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M552.7,475.2c2.6,0,3.9,1.5,3.9,3.3c0,1.3-0.7,2.7-2.6,3.2l2.8,4.6h-2.2l-2.6-4.5h-1.4v4.5h-1.8v-11.1H552.7z  M552.7,476.7h-2v3.7h2c1.4,0,2.1-0.8,2.1-1.9C554.8,477.4,554.1,476.7,552.7,476.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M559.8,475.2h1.8v11.1h-1.8V475.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M569.9,486.4c-3.1,0-5.7-2.4-5.7-5.7c0-3.3,2.5-5.7,5.7-5.7c3.2,0,5.7,2.4,5.7,5.7 C575.6,484.1,573.1,486.4,569.9,486.4z M569.9,484.8c2.2,0,3.8-1.6,3.8-4.1c0-2.5-1.6-4.1-3.8-4.1s-3.8,1.6-3.8,4.1 C566.1,483.2,567.7,484.8,569.9,484.8z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_41",
    className: "st7",
    cx: 593.5,
    cy: 481.6,
    r: 1.9
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_42",
    className: "st7",
    cx: 723.8,
    cy: 481.6,
    r: 1.9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChileElige2024);
export default __webpack_public_path__ + "static/media/chile-elige-2024.87f185b3fa7369b9fb1b297ddd20b0a9.svg";
export { ForwardRef as ReactComponent };